import { Box, Grid, Typography, Link, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

const FooterSection = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.secondary,
  padding: theme.spacing(6, 0),
  marginTop: theme.spacing(8),
  borderTop: `1px solid ${theme.palette.divider}`,
}));

const FooterLink = styled(Link)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textDecoration: 'none',
  fontSize: 14,
  '&:hover': {
    color: theme.palette.text.primary,
    textDecoration: 'underline',
  },
}));

const SocialIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.secondary,
  '&:hover': {
    backgroundColor: 'rgba(15, 23, 42, 0.06)',
    color: theme.palette.text.primary,
  },
}));

export default function Footer() {
  return (
    <FooterSection>
      <Box sx={{ px: { xs: 3, md: 8 } }}>
        <Grid container spacing={4} justifyContent="space-between" alignItems="flex-start" id="footer">
          <Grid item xs={12} md={3}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
              <img src="/images/logos/main.png" alt="Scott Development Logo" style={{ width: 44, height: 'auto' }} />
              <Typography variant="subtitle2" sx={{ letterSpacing: '0.18em' }}>
                SCOTT DEVELOPMENT
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ maxWidth: 320 }}>
              Boutique real estate development and brokerage firm focused on sustainable, high-quality projects in and around the Tahoe Basin.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="subtitle2" gutterBottom sx={{ letterSpacing: '0.16em', textTransform: 'uppercase' }}>
              Office
            </Typography>
            <Typography variant="body2" sx={{ whiteSpace: 'pre-line', mb: 2 }}>
              590 Lakeshore Blvd.
              {'\n'}
              Incline Village, NV 89451
            </Typography>
            <Typography variant="body2" sx={{ mb: 0.5 }}>
              <PhoneIcon fontSize="small" sx={{ mr: 1 }} />
              <FooterLink href="tel:+17752400241">
                (775) 240-0241
              </FooterLink>
            </Typography>
            <Typography variant="body2">
              <EmailIcon fontSize="small" sx={{ mr: 1 }} />
              <FooterLink href="mailto:vince@scottdevelopmentcompanies.com">
                vince@scottdevelopmentcompanies.com
              </FooterLink>
            </Typography>
          </Grid>
          <Grid item xs={6} md={3}>
            <Typography variant="subtitle2" gutterBottom sx={{ letterSpacing: '0.16em', textTransform: 'uppercase' }}>
              Connect
            </Typography>
            <Box sx={{ mt: 1.5, display: 'flex', gap: 1 }}>
              <SocialIconButton aria-label="Facebook" onClick={() => window.open('https://www.facebook.com/vince.scott.790', '_blank')}>
                <FacebookIcon />
              </SocialIconButton>
              <SocialIconButton aria-label="LinkedIn" onClick={() => window.open('https://www.linkedin.com/in/vince-scott-a70b3712/', '_blank')}>
                <LinkedInIcon />
              </SocialIconButton>
            </Box>
          </Grid>
        </Grid>
        <Box
          sx={{
            mt: 4,
            borderTop: theme => `1px solid ${theme.palette.divider}`,
            pt: 2,
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 1,
          }}
        >
          <Typography variant="caption">
            © {new Date().getFullYear()} Scott Development Companies. All rights reserved.
          </Typography>
        </Box>
      </Box>
    </FooterSection>
  );
}
